<template>
  <div class="static-page">
    <HeadNav selectedLanguage="en" page="privacy" />
    <Breadcrumbs :items="[{ name: 'Privacy Policy' }]" />

    <main class="static-content">
      <h1>Privacy Policy</h1>

      <p>Your privacy is important to us. This Privacy Policy explains how we collect and use information when you visit our website.</p>

      <h2>Information We Collect</h2>
      <p>We do not require visitors to create an account or provide personal information in order to browse this website.</p>
      <p>Like most websites, we may automatically collect non-personal information such as browser type, device information, operating system, IP address, referring pages, and anonymous usage statistics to improve our services.</p>
      <p>If you contact us by email or through our contact form, we will use the information you provide only to respond to your inquiry.</p>

      <h2>Cookies</h2>
      <p>This website may use cookies to improve your browsing experience, remember preferences, and measure website performance. You can disable cookies through your browser settings if you prefer.</p>

      <h2>Third-Party Services</h2>
      <p>We may use trusted third-party services, including analytics and advertising providers, which may collect information according to their own privacy policies.</p>

      <h2>External Links</h2>
      <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites.</p>

      <h2>Data Security</h2>
      <p>We take reasonable measures to protect the information we collect, but no website or internet transmission can be guaranteed to be completely secure.</p>

      <h2>Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be published on this page with the latest revision date.</p>
      <p>If you have any questions about this Privacy Policy, please contact us.</p>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
    Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.static-content {
  width: 80%;
  max-width: 980px;
  margin: 28px auto 96px;
  color: #121212;
  line-height: 1.7;
}

h1 {
  margin: 0 0 24px;
}

h2 {
  margin: 28px 0 12px;
}

p {
  margin: 0 0 16px;
}

@media (max-width: 768px) {
  .static-content {
    width: 88%;
    margin-bottom: 112px;
  }
}
</style>
